import { render, staticRenderFns } from "./InterbankAccountTracking.vue?vue&type=template&id=30440765"
import script from "./InterbankAccountTracking.vue?vue&type=script&lang=js"
export * from "./InterbankAccountTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports